export {} from './declarations';

export {} from './models';

export {} from './utilities';

import { IntlBridge } from './utilities';
import { shortcuts, kpis, recentAssignments } from './features';
export const ShortcutsWidget = IntlBridge(shortcuts.Component);
export const { reducer: shortcutsReducer } = shortcuts;
export const KpisWidget = IntlBridge(kpis.Component);
export const { reducer: kpisReducer } = kpis;
export const RecentAssignmentsWidget = IntlBridge(recentAssignments.Component);
export const { reducer: recentAssignmentsReducer } = recentAssignments;

export {} from './devHarness';
